import {useMutation} from '@tanstack/react-query';

import {apiSwr, routes} from '_api';
import {updateProfile, uploadPhoto} from "_api/fetchers/profile";
import type {User} from "_types/models/User";
import type {UserUpdate} from "_types/requests/user";
import {updateUser} from "_api/fetchers/users";
import {toastRequestError} from "_utils/axios";


export function useUploadPhoto() {
    const mutationKey = [...routes.profile.photo] as const;

    return useMutation({
        mutationKey,
        mutationFn: async (payload: FormData) => {
            return uploadPhoto(mutationKey, payload);
        },

        onMutate: async d => {
            await apiSwr.cancelQueries({queryKey: [...routes.auth.currentUser]});
        },
        onSuccess: async d => {
            await apiSwr.invalidateQueries({queryKey: [...routes.auth.currentUser]});
        },
        onError: err => {

        },
    });
}

export function useUpdateUserProfile() {
    const mutationKey = [...routes.profile.update] as const;

    return useMutation({
        mutationKey,
        mutationFn: async (payload: { name: string }) => {
            return updateProfile(mutationKey, payload);
        },

        onMutate: async d => {
            await apiSwr.cancelQueries({queryKey: [...routes.users.search]});
            await apiSwr.cancelQueries({queryKey: [...routes.auth.currentUser]});
        },
        onSuccess: async d => {
            await apiSwr.invalidateQueries({queryKey: [...routes.users.search]});
            await apiSwr.invalidateQueries({queryKey: [...routes.auth.currentUser]});
        },
        onError: err => {
            toastRequestError(err);
        },
    });
}
